/**
 * Tasks Gantt feature flags for /schedule/tasks.
 * Does not own chart state or loading.
 */

/**
 * Quantity P|A panel (React sibling of the DHTMLX grid).
 * Parked: Look ahead is currently filtered Schedule + Gantt only.
 * Flip to true to restore the final targets-editing surface without rewriting wiring.
 */
export const ENABLE_TARGETS_QUANTITY_PANEL = false;

/** Draggable floating location panel when true; original modal when false. */
export const USE_FLOATING_LOCATION_PANEL = true;
